import { type StoryblokProductSearchFilterOffersType } from '../../../../storyblok'
import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

import { storyblokProductSearchFiltersGetValuesFromString } from './storyblokProductSearchFiltersGetValuesFromString'

export const storyblokProductSearchFiltersGetOffers = (
  offersFilters: StoryblokProductSearchFilterOffersType,
): Partial<
  Pick<
    StoryblokProductSearchFiltersType,
    'categoryCodes' | 'discountInPercent' | 'prescriptionMedicine'
  >
> => {
  return {
    categoryCodes: storyblokProductSearchFiltersGetValuesFromString(
      offersFilters.categoryIds,
    ),
    discountInPercent: { min: 40 },
    prescriptionMedicine: false,
  }
}
